import React from 'react';

import { Button, Dialog, Stack, Typography } from '@mui/material';

interface IProps {
  openConfirmation: boolean;
  onClose: VoidFunction;
}

const HighlightError: React.FC<IProps> = ({ openConfirmation, onClose }) => {
  return (
    <Dialog
      open={openConfirmation}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Stack spacing={2} m={3}>
        <Typography sx={{ textAlign: 'justify' }}>
          <span style={{ fontWeight: 'bold' }}>Oops!</span> It seems the text
          highlighted for this approval cannot be automatically found in the
          document. Please find it in the document using the find/search
          feature. If you cannot find the text,{' '}
          <span style={{ fontWeight: 'bold' }}>we suggest</span>, you do not
          approve the deviation card and get in touch with the requestor for
          further action.
        </Typography>
        <Stack direction="row" justifyContent="end">
          <Button variant="contained" onClick={onClose}>
            Understood
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default HighlightError;
